module.exports = __webpack_public_path__ + "img/card-img2.a54c2c27.png";